import React from 'react'

// Temporary public "Coming Soon" splash. Your real homepage (LandingPage) stays
// safe in the repo — to launch, just point the "/" route back to <LandingPage />.
export default function ComingSoon() {
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    * { box-sizing:border-box; margin:0; padding:0; }
    .cs-wrap { min-height:100vh; background:#E9EAEC; display:flex; align-items:center; justify-content:center; padding:48px 24px; font-family:'Plus Jakarta Sans',-apple-system,BlinkMacSystemFont,system-ui,sans-serif; color:#151715; -webkit-font-smoothing:antialiased; }
    .cs-inner { max-width:640px; width:100%; text-align:center; }
    .cs-logo { width:clamp(240px,42vw,380px); height:auto; margin:0 auto; display:block; }
    .cs-bar { width:56px; height:3px; background:#800020; border-radius:2px; margin:30px auto; }
    .cs-title { font-size:clamp(30px,4.4vw,46px); font-weight:800; letter-spacing:-.025em; line-height:1.12; margin-bottom:22px; }
    .cs-title .accent { color:#4D4E8D; }
    .cs-sub { font-size:clamp(16px,2vw,19px); font-weight:500; color:#5C6065; line-height:1.75; max-width:30em; margin:0 auto 42px; }
    .cs-card { background:#fff; border-radius:22px; padding:34px 30px; box-shadow:0 18px 50px rgba(21,23,21,0.07); display:inline-block; max-width:90%; }
    .cs-card-label { font-size:14px; font-weight:600; color:#5E8A72; letter-spacing:.03em; margin-bottom:18px; }
    .cs-mail { display:inline-block; background:#4D4E8D; color:#fff; font-size:16px; font-weight:700; text-decoration:none; padding:15px 28px; border-radius:13px; box-shadow:0 12px 30px rgba(77,78,141,0.28); transition:background .2s, transform .15s; word-break:break-all; }
    .cs-mail:hover { background:#41427a; transform:translateY(-2px); }
    .cs-mail:focus-visible { outline:2px solid #4D4E8D; outline-offset:3px; }
    .cs-sign { margin-top:40px; font-size:15px; font-weight:700; color:#151715; }
    .cs-sign span { color:#5C6065; font-weight:500; }
  `
  return (
    <>
      <style>{styles}</style>
      <main className="cs-wrap" role="main">
        <div className="cs-inner">
          <img className="cs-logo" src="/nsv_logo.png?v=2" alt="Notary Signing Vault, LLC — Nationwide Notary Professionals Network" onError={e => { e.target.style.display = 'none' }} />
          <div className="cs-bar"></div>
          <h1 className="cs-title">Something amazing is <span className="accent">on the way.</span></h1>
          <p className="cs-sub">We're putting the finishing touches on a calm, trusted home for nationwide notary signings. We can't wait to show you &mdash; launching soon.</p>
          <div className="cs-card">
            <div className="cs-card-label">Curious or have questions? I'd love to hear from you.</div>
            <a className="cs-mail" href="mailto:nancy@notarysigningvault.com">nancy@notarysigningvault.com</a>
          </div>
          <p className="cs-sign">Nancy Phillips <span>&mdash; Founder &amp; CEO, Notary Signing Vault</span></p>
        </div>
      </main>
    </>
  )
}
